import { ComponentType, FC, lazy, Suspense, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Redirect, Route } from 'react-router-dom'

import Loader from '../components/pages/Loader'
import { authActions, userActions } from '../ducks/actions'
import { isAuthorized, isRegisterCompleted } from '../ducks/selectors'
import { history } from '../helpers'
import { RouteType } from './types'

type PrivatePageProps = {
  authorized: boolean
  registerCompleted: boolean
  registerPath: boolean
  PageComponent: ComponentType
}

const PrivatePage: FC<PrivatePageProps> = ({
  authorized,
  registerCompleted,
  registerPath,
  PageComponent,
}) => {
  const dispatch = useDispatch()

  useEffect(() => {
    if (authorized) {
      dispatch(userActions.fetchCurrentUser(() => {}))
    }
  }, [authorized, dispatch])

  if (!authorized) {
    return <Redirect to='/' />
  }
  if (registerPath && registerCompleted) {
    return <Redirect to='/home' />
  }
  if (!registerPath && !registerCompleted) {
    return <Redirect to='/register' />
  }
  return (
    <Suspense fallback={<Loader />}>
      <PageComponent />
    </Suspense>
  )
}

const PrivateRoute: FC<RouteType> = ({ path, page, ...rest }) => {
  const dispatch = useDispatch()
  const replace = history.useReplace()
  const authorized = useSelector(isAuthorized)
  const registerCompleted = useSelector(isRegisterCompleted)
  const PageComponent = lazy(() => import(`../components/pages/${page}`))
  const registerPath = path === '/register'

  if (!authorized) {
    dispatch(authActions.logoutRequest({
      callback: (success) => {
        if (success) replace('/')
      }
    }))
  }

  return (
    <Route
      exact
      {...rest}
      path={path}
      render={() => (
        <PrivatePage
          authorized={authorized}
          registerCompleted={registerCompleted}
          registerPath={registerPath}
          PageComponent={PageComponent}
        />
      )}
    />
  )
}

export default PrivateRoute
